import commons from './commons.json';
import coverage from './coverage.json';
import errors from './errors.json';
import header from './header.json';
import lobby from './lobby.json';
import summary from './summary.json';

import number from './modules/number.json';

import subscribe from './endings/subscribe.json';

export default {
  commons,
  coverage,
  errors,
  header,
  modules: {
    number
  },
  endings: {
    subscribe
  },
  lobby,
  summary
};



// WEBPACK FOOTER //
// ./src/locale/pt/index.js